<template>
  <div>
    <h1 class="title">
      {{ deviceName }}-火灾报警控制器操作台({{ deviceVersion | dic("SENU095") }}
      )
    </h1>
    <div class="gts200-container">
      <div class="main-box flex-between">
        <!-- 左侧屏幕 -->
        <div class="left-screen">
          <div class="screen-top flex-between">
            <div class="screen">
              <div class="inside-screen">
                {{ timeH }}
              </div>
            </div>
            <div class="yuan column-center">
              <div class="doit"></div>
              <div class="doit"></div>
            </div>
            <div class="screen">
              <div class="inside-screen">
                {{ timeM }}
              </div>
            </div>
          </div>
          <div class="screen-bottom">
            <div class="full-screen">
              {{ respondText }}
            </div>
          </div>
        </div>
        <!-- 右侧键盘 -->
        <div class="right-keybord">
          <div class="top-key flex-between">
            <div
              v-for="(item, index) in leftList"
              :key="index"
              class="light-item flex-row"
            >
              <div class="light">
                <span
                  class="point checked"
                  :class="[btnClass[item.type]]"
                ></span>
                <span
                  class="name"
                  :class="[item.title.length === 2 ? 'letter24' : '']"
                  >{{ item.title }}</span
                >
              </div>
            </div>
          </div>
          <div class="bottom-key flex-between">
            <div
              v-for="(items, indexs) in keyBordList"
              :key="indexs"
              :name="items.value"
              class="key-btn ctl-btn"
            >
              <i
                v-show="items.text === '联动检查'"
                class="icon iconfont-lunan icon-lunan-kongge"
              ></i>
              <span class="num-span">{{ items.num }}</span>
              <i
                v-show="items.value === '5'"
                class="icon iconfont-lunan icon-lunan-xiangshang"
              ></i>
              <i
                v-show="items.value === '6'"
                class="icon iconfont-lunan icon-lunan-xiangxia"
              ></i>
              <span class="text-span">{{ items.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "./minx";
import { Dic } from "$utils";
export default {
  mixins: [mixin],
  props: {
    deviceName: {
      type: String,
      default: () => {
        return "";
      },
    },
    deviceVersion: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      leftList: [
        {
          title: "火警",
          type: "1",
        },
        {
          title: "故障",
          type: "1",
        },
        {
          title: "动作",
          type: "1",
        },
        {
          title: "蜀高",
          type: "1",
        },
        {
          title: "消音",
          type: "1",
        },
        {
          title: "启动",
          type: "1",
        },
        {
          title: "主动故障",
          type: "1",
        },
        {
          title: "自动允许",
          type: "1",
        },
        {
          title: "手动允许",
          type: "1",
        },
        {
          title: "防盗开启",
          type: "1",
        },
        {
          title: "工作",
          type: "1",
        },
        {
          title: "备电故障",
          type: "1",
        },
        {
          title: "气体喷洒",
          type: "1",
        },
        {
          title: "喷洒请求",
          type: "1",
        },
        {
          title: "喷洒允许",
          type: "1",
        },
      ],
      btnClass: {
        0: "red",
        1: "green",
        2: "gray",
      },
      middleList: [
        {
          title: "火警传输",
          list: [
            {
              title: "手动告警",
              type: "0",
            },
            {
              title: "系统故障",
              type: "0",
            },
          ],
        },
        {
          title: "气体灭火",
          list: [
            {
              title: "喷洒请求",
              type: "0",
            },
            {
              title: "气体喷洒",
              type: "0",
            },
          ],
        },
      ],
      keyBordList: [
        {
          num: "1",
          text: "自检",
          value: "10",
        },
        {
          num: "2",
          text: "锁键",
          value: "11",
        },
        {
          num: "3",
          text: "打印控制",
          value: "12",
        },
        {
          num: "+",
          text: "窗口切换",
          value: "34",
        },
        {
          num: "=",
          text: "消音",
          value: "37",
        },
        {
          num: "4",
          text: "隔离",
          value: "13",
        },
        {
          num: "5",
          text: "取消隔离",
          value: "14",
        },
        {
          num: "6",
          text: "喷洒控制",
          value: "15",
        },
        {
          num: "X",
          text: "启动控制",
          value: "35",
        },
        {
          num: "",
          text: "",
          value: "5",
        },
        {
          num: "7",
          text: "启动",
          value: "16",
        },
        {
          num: "8",
          text: "停动",
          value: "17",
        },
        {
          num: "9",
          text: "系统设置",
          value: "18",
        },
        {
          num: "TAB",
          text: "防备控制",
          value: "36",
        },
        {
          num: "",
          text: "",
          value: "6",
        },
        {
          num: "*",
          text: "设备检查",
          value: "19",
        },
        {
          num: "0",
          text: "记录检查",
          value: "9",
        },
        {
          num: "",
          text: "联动检查",
          value: "31",
        },
        {
          num: "",
          text: "确认",
          value: "3",
        },
        {
          num: "",
          text: "取消",
          value: "4",
        },
      ],
    };
  },
  methods: {
    changeBgColor(isSuccess, btnListCode) {
      console.log(isSuccess, btnListCode);
      // btnListCode.forEach((item) => {
      //   let divItem = document.getElementsByName(item);
      //   divItem.forEach((data) => {
      //     if (isSuccess) data.classList.add("greenBg");
      //     else data.classList.add("redBg");
      //   });
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.checkedIng {
  @include set_theme_color(color, main-button-bgcolor);
}
.ctl-btn {
  &:hover {
    opacity: 0.6 !important;
    cursor: pointer;
  }
}
.redBg {
  background: red !important;
  color: #fff !important;
}

.greenBg {
  background: green !important;
}
.rChecked {
  background: red !important;
}
.title {
  font-size: 18px;
  margin-bottom: 10px;
  text-align: center;
  line-height: 20px;
}
.gts200-container {
  width: 100%;
  height: 50vh;
  background: linear-gradient(180deg, #7e7e7e 0%, #777777 100%);
  opacity: 1;
  border-radius: 30px;
  padding: 10px;
  .red {
    background: linear-gradient(180deg, #ff0000 0%, #800000 100%);
  }
  .green {
    background: linear-gradient(180deg, #00ce6f 0%, #006738 100%);
  }
  .gray {
    background: linear-gradient(180deg, #eeeeee 0%, #a1a1a1 100%);
  }
  .letter24 {
    letter-spacing: 24px;
  }
  .lh40 {
    line-height: 40px;
  }
  .lh18 {
    line-height: 18px;
  }
  .light-item {
    width: 20%;
    font-size: 12px;
    .light {
      // margin-right: 5px;
      display: flex;
      flex-direction: row;
      text-align: left;
      .point {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50px;
        box-shadow: 0px 0px 0px 3px #fff;
        margin-right: 5px;
      }
      .name {
        // margin-left: 5px;
        width: 72px;
      }
    }
  }
  .main-box {
    width: 100%;
    height: 100%;
    background: #646464;
    opacity: 1;
    border-radius: 20px;
    padding: 10px;
    .left-screen {
      width: 40%;
      height: 100%;
      background: #646464;
      border: 1px solid #898989;
      opacity: 1;
      border-radius: 18px;
      padding: 22px 10px;
      .screen-top {
        width: 100%;
        height: 50%;
        box-sizing: border-box;
        .screen {
          width: 100px;
          height: 70%;
          background: #000000;
          border: 1px solid #ffffff;
          opacity: 1;
          border-radius: 15px;
          padding: 4px;
          .inside-screen {
            width: 100%;
            font-size: 40px;
            line-height: 100px;
            height: 100%;
            background: #adbfb2;
            border: 1px solid #555a56;
            opacity: 1;
            border-radius: 12px;
          }
        }
        .yuan {
          width: 40px;
          height: 70%;
          align-items: center;
          .doit {
            width: 14px;
            height: 14px;
            background: #ffffff;
            border: 1px solid #707070;
            border-radius: 50%;
            opacity: 1;
            &:nth-child(1) {
              margin-bottom: 20px;
            }
          }
        }
      }
      .screen-bottom {
        height: 50%;
        width: 100%;
        background: #000000;
        border: 1px solid #ffffff;
        opacity: 1;
        border-radius: 15px;
        padding: 5px;
        .full-screen {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: #adbfb2;
          border: 1px solid #555a56;
          opacity: 1;
          border-radius: 10px;
        }
      }
    }
    .right-keybord {
      width: 60%;
      .top-key {
        width: 100%;
        height: 40%;
        flex-wrap: wrap;
        margin: 50px 0px 0px 10px;
      }
      .bottom-key {
        width: 100%;
        height: 50%;
        flex-wrap: wrap;
        margin-left: 8px;
        .key-btn {
          width: 68px;
          height: 33px;
          border: 1px solid #404040;
          background: linear-gradient(180deg, #767676 0%, #262626 100%);
          opacity: 1;
          border-radius: 18px;
          text-align: center;
          margin-bottom: 5px;
          margin-right: 10px;
          font-size: 12px;
          &:nth-child(10) {
            line-height: 30px;
          }
          &:nth-child(15) {
            line-height: 30px;
          }
          &:nth-child(19) {
            line-height: 30px;
          }
          &:nth-child(20) {
            line-height: 30px;
          }
          span {
            display: block;
          }
        }
      }
    }
  }
}
</style>